(function () {
  // Inject styles
  const style = document.createElement('style');
  style.innerHTML = `
  #dripp-accessibility-wrapper {
    position: fixed;
    /* Sits above the Tawk.to chat bubble in the bottom-left corner. */
    bottom: 90px;
    left: 20px;
    z-index: 9999;
  }

  #dripp-accessibility-fab {
    background: #000;
    color: #fff;
    border: none;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  #dripp-accessibility-fab svg {
    width: 20px;
    height: 20px;
    fill: white;
  }

  #dripp-accessibility-panel {
    background: var(--color-bg-elev-2, #10131c);
    color: var(--color-text, #f4f6fb);
    border: 1px solid var(--color-line, #1a1d28);
    border-radius: 10px;
    box-shadow: 0 14px 40px rgba(0,0,0,0.5);
    padding: 12px;
    width: 260px;
    position: absolute;
    bottom: 70px;
    left: 0;
    transform: translateY(100%);
    opacity: 0;
    transition: all 0.3s ease;
    pointer-events: none;
    font-family: inherit;
  }

  #dripp-accessibility-panel h4,
  #dripp-accessibility-panel strong {
    color: var(--color-text, #f4f6fb);
  }

  #dripp-accessibility-panel strong {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
  }

  #dripp-accessibility-wrapper.active #dripp-accessibility-panel {
    transform: translateY(0%);
    opacity: 1;
    pointer-events: auto;
  }

  #dripp-accessibility-panel h4 {
    margin: 0 0 10px;
    font-size: 16px;
  }

  .dripp-accessibility-group {
    margin-bottom: 12px;
  }

  #dripp-accessibility-panel button {
    display: block;
    width: 100%;
    margin: 4px 0;
    padding: 6px 10px;
    font-size: 14px;
    color: var(--color-text, #f4f6fb);
    border: 1px solid var(--color-line, #1a1d28);
    background: rgba(255,255,255,0.04);
    cursor: pointer;
    border-radius: 6px;
    text-align: left;
  }

  #dripp-accessibility-panel button:hover {
    background: rgba(255,255,255,0.1);
  }

  .dripp-accessibility-controls {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    gap: 6px;
  }

  .dripp-accessibility-controls button {
    width: 26px;
    height: 26px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(255,255,255,0.08);
    color: var(--color-text, #f4f6fb);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dripp-accessibility-controls button:hover {
    background: rgba(255,255,255,0.18);
  }

  .dripp-accessibility-controls svg {
    width: 14px;
    height: 14px;
    stroke: currentColor;
  }

  /* Accessibility Styles */
  .dripp-invert      { filter: invert(1) hue-rotate(180deg) !important; }
  .dripp-dark        { filter: brightness(0.8) contrast(1.5) !important; }
  .dripp-light       { filter: brightness(1.2) contrast(1.1) !important; }
  .dripp-saturate    { filter: saturate(2) !important; }
  .dripp-desaturate  { filter: saturate(0.3) !important; }
  .dripp-grayscale   { filter: grayscale(1) !important; }

  .dripp-bigger-text * {
    font-size: 110% !important;
  }

  .dripp-readable-fonts * {
    font-family: Arial, sans-serif !important;
  }

  .dripp-highlight-titles h1,
  .dripp-highlight-titles h2,
  .dripp-highlight-titles h3,
  .dripp-highlight-titles h1 *,
  .dripp-highlight-titles h2 *,
  .dripp-highlight-titles h3 * {
    background: #ffe14d !important;
    color: #000 !important;
    /* Some headings use gradient text-fill (transparent); force solid dark text. */
    -webkit-text-fill-color: #000 !important;
    text-shadow: none !important;
  }

  .dripp-highlight-links a {
    background: lightblue;
    text-decoration: underline !important;
  }

  .dripp-stop-animation * {
    animation: none !important;
    transition: none !important;
  }
  `;
  document.head.appendChild(style);

  const fabIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M2 8.5C2 5.46 4.46 3 7.5 3h9C19.54 3 22 5.46 22 8.5v7c0 3.04-2.46 5.5-5.5 5.5h-9C4.46 21 2 18.54 2 15.5v-7zm7.5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm7 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM5.5 16a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm13 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
    </svg>
  `;

  const wrapper = document.createElement('div');
  wrapper.id = 'dripp-accessibility-wrapper';
  wrapper.innerHTML = `
    <button id="dripp-accessibility-fab" type="button" aria-label="Accessibility options" aria-expanded="false" aria-controls="dripp-accessibility-panel">
      ${fabIcon}
    </button>

    <div id="dripp-accessibility-panel" role="dialog" aria-label="Accessibility settings">
      <div class="dripp-accessibility-controls">
        <button id="dripp-reset-btn" type="button" title="Reset" aria-label="Reset accessibility settings">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M12 5v2a5 5 0 1 1-5 5H5a7 7 0 1 0 7-7z"/>
            <path d="M13 2v4h-4"/>
          </svg>
        </button>
        <button id="dripp-close-btn" type="button" title="Close" aria-label="Close accessibility panel">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18"/>
          </svg>
        </button>
      </div>

      <h4>Accessibility Settings</h4>

      <div class="dripp-accessibility-group">
        <strong>Color Adjustments</strong>
        <button type="button" data-action="invert">Invert Colors</button>
        <button type="button" data-action="dark">Dark Contrast</button>
        <button type="button" data-action="light">Light Contrast</button>
        <button type="button" data-action="saturate">High Saturation</button>
        <button type="button" data-action="desaturate">Low Saturation</button>
        <button type="button" data-action="grayscale">Desaturate</button>
      </div>

      <div class="dripp-accessibility-group">
        <strong>Content Adjustments</strong>
        <button type="button" data-action="bigger-text">Bigger Text</button>
        <button type="button" data-action="readable-fonts">Readable Fonts</button>
        <button type="button" data-action="highlight-titles">Highlight Titles</button>
        <button type="button" data-action="highlight-links">Highlight Links</button>
      </div>

      <div class="dripp-accessibility-group">
        <strong>Other</strong>
        <button type="button" data-action="stop-animation">Stop Animation</button>
      </div>
    </div>
  `;
  document.body.appendChild(wrapper);

  const fab = wrapper.querySelector('#dripp-accessibility-fab');
  const panel = wrapper.querySelector('#dripp-accessibility-panel');
  const buttons = panel.querySelectorAll('button[data-action]');
  const html = document.documentElement;

  const allClasses = [
    'dripp-invert', 'dripp-dark', 'dripp-light',
    'dripp-saturate', 'dripp-desaturate', 'dripp-grayscale',
    'dripp-bigger-text', 'dripp-readable-fonts',
    'dripp-highlight-titles', 'dripp-highlight-links',
    'dripp-stop-animation'
  ];

  function setPanelOpen(open) {
    wrapper.classList.toggle('active', open);
    fab.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  fab.addEventListener('click', () => {
    setPanelOpen(!wrapper.classList.contains('active'));
  });

  wrapper.querySelector('#dripp-close-btn').addEventListener('click', () => {
    setPanelOpen(false);
  });

  wrapper.querySelector('#dripp-reset-btn').addEventListener('click', () => {
    allClasses.forEach(cls => html.classList.remove(cls));
    localStorage.removeItem('dripp-accessibility');
  });

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const action = `dripp-${btn.dataset.action}`;
      html.classList.toggle(action);

      const current = JSON.parse(localStorage.getItem('dripp-accessibility') || '[]');
      if (html.classList.contains(action)) {
        current.push(action);
      } else {
        const idx = current.indexOf(action);
        if (idx !== -1) current.splice(idx, 1);
      }
      localStorage.setItem('dripp-accessibility', JSON.stringify([...new Set(current)]));
    });
  });

  const saved = JSON.parse(localStorage.getItem('dripp-accessibility') || '[]');
  saved.forEach(cls => html.classList.add(cls));
})();
